// extracted by mini-css-extract-plugin
export default {"card":"YQ-z","defaultCard":"ZQ-z","cardDetails":"_Q-z","cardActions":"aR-z","separator":"bR-z"};